(() => {
  const init = () => {
    document.querySelectorAll('.facets-block-wrapper--vertical:not(#filters-drawer)').forEach((wrapper) => {
      if (wrapper.dataset.tclCollapseReady === 'true') return;
      const button = wrapper.querySelector('[data-tcl-filter-sidebar-toggle]');
      if (!button) return;
      button.addEventListener('click', () => {
        const collapsed = wrapper.classList.toggle('tcl-filter-sidebar-collapsed');
        button.setAttribute('aria-expanded', String(!collapsed));
        const text = button.querySelector('.tcl-filter-toggle-text');
        const arrow = button.querySelector('[aria-hidden="true"]');
        if (text) text.textContent = collapsed ? 'Openen' : 'Inklappen';
        if (arrow) arrow.textContent = collapsed ? '›' : '‹';
      });
      wrapper.dataset.tclCollapseReady = 'true';
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
